import React, { useState } from "react";
import peliculas from "../../db.json";
import estilo from "../../styles/Content.module.css";
import Tarjeta from "../../components/Tarjeta";
import Paginacion from "../../components/Paginacion";
import Ranking from "../../components/Raking";
function Documental() {
  //estrenos
  const estrenos = peliculas
    .map(
      ({
        id,
        titulo,
        portada,
        estreno,
        año,
        calificacion,
        tipo,
        generos,
        sinopsis,
        trailer,
        servidores,
      }) => ({
        id: `${id}`,
        titulo,
        portada,
        estreno,
        año,
        calificacion,
        tipo,
        generos: `${generos.map((g) => g.nombre).join(", ")}`,
        sinopsis,
        trailer,
        servidores,
      })
    )
    .filter((e) => e.generos.indexOf("Documental") > -1);
  //   console.log(estrenos);  //paginación
  const [elementoPagina, setElementoPagina] = useState(1);
  const [elementosPorPagina] = useState(12);

  const ultimoIndice = elementoPagina * elementosPorPagina;
  const primerIndice = ultimoIndice - elementosPorPagina;
  const elementosSalida = estrenos.slice(primerIndice, ultimoIndice);

  const paginacion = (numeroPagina) => setElementoPagina(numeroPagina);
  return (
    <div className={estilo.general}>
      <Ranking></Ranking>
      <div className={estilo.linea}></div>
      <div className={estilo.grid_peliculas}>
        {elementosSalida.map((e) => (
          <Tarjeta key={e.id} pelicula={e}></Tarjeta>
        ))}
      </div>{" "}
      <div>
        <Paginacion
          elementosPorPagina={elementosPorPagina}
          elementosTotales={estrenos.length}
          paginacion={paginacion}
        />
      </div>
    </div>
  );
}

export default Documental;
